import { useMemo } from 'react';
import { useSignupEmbedder } from 'signup-embedder/hooks/useSignupEmbedder';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { useIsWideStep } from '../hooks/useIsWideStep';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { Data } from 'signup-constants/signupData/Data';
import { useSignupData } from '../signup-data/useSignupData';
import { Step } from 'signup-constants/Step';
import { getMessageComponent } from './getMessageComponent';
import { getMessageKey } from './getMessageKey';
import { Intent } from 'signup-constants/Intent';
import { getIntentKey } from '../routing/getIntentKey';
import { MessageKey } from './MessageKey';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
const useMessageKey = () => {
  const {
    currentStep
  } = useCurrentStep();
  const {
    data: industry
  } = useSignupData(Data.Industry);
  const {
    isMobile
  } = useResponsiveness();
  const intentKey = getIntentKey();
  if (currentStep === Step.LandingPage && intentKey === Intent.blogIdeasGenerator) {
    return {
      messageKey: MessageKey.BlogGenerator
    };
  }
  return {
    messageKey: getMessageKey({
      currentStep,
      industry,
      isMobile
    })
  };
};
export const useMessage = () => {
  const {
    isWideStep
  } = useIsWideStep();
  const {
    shouldShowMessaging
  } = useSignupEmbedder();
  const {
    messageKey
  } = useMessageKey();
  const {
    isActive: isInstanceOfSignupEmbedder
  } = useSignupEmbedder();
  const {
    isAssignedToVariant: isACQ0143Variant
  } = useExperiment(ExperimentKeys.ACQ0143, TrackWhen.never);
  const hideMessage = messageKey === MessageKey.CompanyDomain && !isACQ0143Variant();
  const MessageComponent = useMemo(() => {
    if (messageKey && !hideMessage) {
      return getMessageComponent({
        messageKey
      });
    }
    return null;
  },
  // Do not re-render when just the industry is changing and not the step: that's when the user is typing.
  // We can change this once we make it a dropdown.
  [messageKey, hideMessage]);
  const noMessagingDisplayed = isInstanceOfSignupEmbedder && !shouldShowMessaging || isWideStep || !messageKey;
  const shouldDisplayMessaging = !noMessagingDisplayed;
  return {
    component: MessageComponent,
    shouldDisplayMessaging: shouldDisplayMessaging && MessageComponent
  };
};